import { workplaceStyles } from '../workplaceStyles';
import units from 'constants/units';

export const getFixedQuantities = (n) => [
  { id: workplaceStyles.traditional.id, fx: () => n },
  { id: workplaceStyles.moderate.id, fx: () => n },
  { id: workplaceStyles.progressive.id, fx: () => n },
];

export const getHeadcountBasedQuantites = (v1, v2, v3) => [
  {
    id: workplaceStyles.traditional.id,
    fx: ({ headcount }) => (headcount >= v1 ? 1 : 0),
  },
  {
    id: workplaceStyles.moderate.id,
    fx: ({ headcount }) => (headcount >= v2 ? 1 : 0),
  },
  {
    id: workplaceStyles.progressive.id,
    fx: ({ headcount }) => (headcount >= v3 ? 1 : 0),
  },
];

export const getInOfficeHeadcountBasedQuantites = (v1, v2, v3) => [
  {
    id: workplaceStyles.traditional.id,
    fx: ({ inOfficeHeadCount }) => Math.round(inOfficeHeadCount / v1),
  },
  {
    id: workplaceStyles.moderate.id,
    fx: ({ inOfficeHeadCount }) => Math.round(inOfficeHeadCount / v2),
  },
  {
    id: workplaceStyles.progressive.id,
    fx: ({ inOfficeHeadCount }) => Math.round(inOfficeHeadCount / v3),
  },
];

export const getInOfficeHeadcountBasedQuantitesWithAddition = (v1, v2, v3, addition = 0) => [
  {
    id: workplaceStyles.traditional.id,
    fx: ({ inOfficeHeadCount }) => Math.trunc(inOfficeHeadCount / v1) + addition,
  },
  {
    id: workplaceStyles.moderate.id,
    fx: ({ inOfficeHeadCount }) => Math.trunc(inOfficeHeadCount / v2) + addition,
  },
  {
    id: workplaceStyles.progressive.id,
    fx: ({ inOfficeHeadCount }) => Math.trunc(inOfficeHeadCount / v3) + addition,
  },
];

export const getAssignedseatsBasedQuantities = (v1, v2, v3) => [
  {
    id: workplaceStyles.traditional.id,
    fx: ({ assignedSeats }) => Math.round(assignedSeats * v1),
  },
  {
    id: workplaceStyles.moderate.id,
    fx: ({ assignedSeats }) => Math.round(assignedSeats * v2),
  },
  {
    id: workplaceStyles.progressive.id,
    fx: ({ assignedSeats }) => Math.round(assignedSeats * v3),
  },
];

export const getMobilityStationQuantity = () => [
  {
    id: workplaceStyles.traditional.id,
    fx: ({ mobilityHeadcount, mobilityRatio }) => Math.round(mobilityHeadcount / mobilityRatio),
  },
  {
    id: workplaceStyles.moderate.id,
    fx: ({ mobilityHeadcount, mobilityRatio }) => Math.round(mobilityHeadcount / mobilityRatio),
  },
  {
    id: workplaceStyles.progressive.id,
    fx: ({ mobilityHeadcount, mobilityRatio }) => Math.round(mobilityHeadcount / mobilityRatio),
  },
];

export const getSize = (width, height) => ({
  width,
  height,
  unitOfMeasure: units.imperial,
});
